import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { formatCFA } from '@/lib/utils'
import { ResponsiveBar } from '@nivo/bar'
import React from 'react'

type Props = {
  data: Array<{ name: string; in: number; outAbs: number; net: number }>
  gridColor: string
  gridOpacity: number
  emptyMsg?: string
}

const BilanCash: React.FC<Props> = ({
  data,
  gridColor,
  gridOpacity,
  emptyMsg = 'Aucune donnée de trésorerie.',
}) => {
  const safe = data?.length ? data : [{ name: '', in: 0, outAbs: 0, net: 0 }]
  return (
    <Card className='min-h-[360px]'>
      <CardHeader>
        <h4 className='text-lg font-medium'>Trésorerie (Entrée / Sortie)</h4>
      </CardHeader>
      <CardContent className='h-[300px]'>
        <ResponsiveBar
          data={safe}
          keys={['in', 'outAbs']}
          indexBy='name'
          margin={{ top: 10, right: 10, bottom: 40, left: 48 }}
          padding={0.3}
          borderRadius={6}
          axisBottom={{ tickPadding: 12, tickRotation: -30 }}
          axisLeft={{ tickPadding: 6 }}
          enableLabel={false}
          groupMode='grouped'
          theme={{
            grid: { line: { stroke: gridColor, strokeOpacity: gridOpacity } },
            tooltip: { container: { fontSize: 12, borderRadius: 8 } },
          }}
          colors={['#16a34a', '#ef4444']} // IN (vert) / OUT (rouge)
          tooltip={({ data }) => (
            <div className='rounded-md border dark:bg-primary bg-white p-2 text-xs shadow'>
              <div>
                Mois: <b>{data.name}</b>
              </div>
              <div>
                Entrées: <b>{formatCFA(Number(data.in))}</b>
              </div>
              <div>
                Sorties: <b>{formatCFA(Number(data.outAbs))}</b>
              </div>
              <div>
                Net: <b>{formatCFA(Number(data.net))}</b>
              </div>
            </div>
          )}
        />
        {!data?.length && (
          <div className='mt-2 text-center text-xs text-muted-foreground'>
            {emptyMsg}
          </div>
        )}
      </CardContent>
    </Card>
  )
}

export default BilanCash
